<template></template>

<script>
    export default {
        name: 'ScrollRetain',
        mounted() {
            window.addEventListener('beforeunload', () => {
                localStorage.setItem("scrollPosition", window.scrollY);
            }, { passive: true });

            if(localStorage.getItem("scrollPosition")) {
                window.scrollTo({top: localStorage.getItem("scrollPosition"), behavior: 'smooth'});
                localStorage.removeItem("scrollPosition");
            }
        },

    }
</script>
